interface WishlistEditFormProps {
    handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
    handleSubmit: (e: React.FormEvent) => void,
    listName: string,
    listIsDefault: boolean,
    isDefaultVisible: boolean,
}

const WishlistEditForm = ({
    handleInputChange,
    handleSubmit,
    listName,
    listIsDefault,
    isDefaultVisible = true,
}: WishlistEditFormProps) => {
    return (
        <div style={{
            textAlign: 'left',
        }}>
            <form onSubmit={handleSubmit}>
                <div className="form-group row">
                    <label
                        htmlFor="modal-input"
                        className="col-sm-3 col-form-label"
                    >
                        List Name
                    </label>
                    <div className="col-sm-7">
                        <input
                            autoFocus={true}
                            maxLength={50}
                            id="modal-input"
                            name="editListName"
                            placeholder="E.g. Nursery, Early Years"
                            className="form-control"
                            onChange={handleInputChange}
                            value={listName}
                            type="text"
                        />
                    </div>
                </div>
                {
                    isDefaultVisible &&
                    <div className="form-group row mb-0">
                        <div className="col-sm-7 offset-sm-3">
                            <div className="form-check">
                                <label className="form-check-label mb-0">
                                    <input
                                        name="editListDefault"
                                        className="form-check-input"
                                        type="checkbox"
                                        onChange={handleInputChange}
                                        checked={listIsDefault}
                                    />
                                    &nbsp;
                                    Make default list
                        </label>
                            </div>
                        </div>
                    </div>
                }
                <button className="hidden" type="submit">Submit</button>
            </form>
        </div>
    );
};

// WishlistEditForm.propTypes = {
//     handleInputChange: PropTypes.func,
//     handleSubmit: PropTypes.func,
//     listName: PropTypes.string,
//     listIsDefault: PropTypes.bool,
//     isDefaultVisible: PropTypes.bool,
// };


export default WishlistEditForm;
